import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, input, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

// translation service
import { TranslatePipe } from '@ngx-translate/core';

import { ClientService } from '../../../../services/client-service';
import { ICentralNote } from '../../../../models/client';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component( {
  selector: 'app-central-notes-component',
  imports: [
    DatePipe,
    RouterLink,
    TranslatePipe,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './central-notes-component.html',
  styleUrl: './central-notes-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
} )
export class CentralNotesComponent implements OnInit, AfterViewInit
{

  constructor(
    private _clientService: ClientService,
    private _cdr: ChangeDetectorRef,
  ) { }

  @ViewChild( MatPaginator ) paginator!: MatPaginator;

  public clientId = input.required<string>();
  public dataSource = new MatTableDataSource<ICentralNote>();
  public notes: ICentralNote[] | undefined;

  protected legend = 'Central Notes';
  protected length = 0;
  protected pageIndex = 0;
  protected pageSizeOptions = [10, 20, 50, 100];

  

  ngOnInit(): void
  {
    
  }

  async ngAfterViewInit(): Promise<void>
  {
    this.dataSource.data = await this._clientService.getCentralNotes( this.clientId() ) || [];
    this.dataSource.paginator = this.paginator;
    this.notes = this.dataSource._pageData( this.dataSource.data );
    this._cdr.detectChanges();
  }

  pageChanged( event: PageEvent )
  {
    this.pageIndex=event.pageIndex;
    this.notes = this.dataSource._pageData( this.dataSource.data );
  }


  applyFilter( event: Event )
  {
    const filterValue = ( event.target as HTMLInputElement ).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();   

    if ( this.dataSource.paginator )
    {
      this.notes = this.dataSource._pageData( this.dataSource.filteredData );
      this.dataSource.paginator.firstPage();
    }
  }
}
